import { Inject, Injectable } from '@angular/core';
import { PAYMENT_METHODS_REPOSITORY, PaymentMethodsRepository } from '@core/repositories/payment-methods.repository';
import { PaymentMethod } from '@shared/interfaces/payment-method';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodsService {
  constructor(
    @Inject(PAYMENT_METHODS_REPOSITORY) protected repository: PaymentMethodsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(paymentMethod: PaymentMethod): Observable<any> {
    return this.repository.add(paymentMethod);
  }

  edit(paymentMethod: PaymentMethod): Observable<any> {
    return this.repository.edit(paymentMethod);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }
}
